// extracted by mini-css-extract-plugin
export default {"overlay":"notSupportedOverlay_overlay__+7euE","overlay__text":"notSupportedOverlay_overlay__text__Zi33H","overlay__image":"notSupportedOverlay_overlay__image__XLPza"};